import { Grid2, Stack, Typography } from "@mui/material";
import "./styles.scss";

export const HowItWorksBlock = ({
  number,
  title,
  description,
  size = {
    xs: 12,
    sm: 6,
    md: 3,
  },
}: {
  number: number;
  title: string;
  description: string;
  size?: any;
}) => {
  return (
    <Grid2 size={size} className="how-it-works-block text-center">
      <Stack className="number" justifyContent="center" alignItems="center">
        <span>{number}</span>
      </Stack>
      <Typography
        variant="body2"
        fontWeight={600}
        component="h4"
        className="title"
      >
        {title}
      </Typography>
      <Typography variant="body1" className="description">
        {description}
      </Typography>
    </Grid2>
  );
};
